export const ResumeTranslationStatus = {
  Pending: 1,
  Failed: 2,
  Completed: 3,
};
